import styled from "styled-components"
import {
  DESKTOP_BREAKPOINT,
} from "manager/views/components/Settlement/constants"
import SettlementMaxWidth from "manager/views/components/Settlement/Common/SettlementMaxWidth"

export const SettlementPadding = styled(SettlementMaxWidth)` 
  padding: 0 15px;
  @media screen and ${DESKTOP_BREAKPOINT} {
    padding-left: ${props => props.paddingLeftRight || props.paddingLeft || '40px'}
    padding-right: ${props => props.paddingLeftRight || props.paddingRight || '40px'}
  }
`

/**
 * A common styled component base for width-constrained cards with rounded boarders in desktop view with padding
 */
export const SettlementCard = styled(SettlementPadding)`
  background-color: white;
  margin-top: ${props => props.marginTop || '10px'}
  @media screen and ${DESKTOP_BREAKPOINT} {
    border-radius: 25px;
    margin-top: 24px;
  }
`

/**
 * A common styled component base for width-constrained cards with rounded boarders in desktop view without padding
 */
export const SettlementForm = styled(SettlementMaxWidth)`
  background-color: white;

  @media screen and ${DESKTOP_BREAKPOINT} {
    border-radius: 25px;
    margin-top: 24px;
    :last-child {
        margin-bottom: 60px;
    }
  }
`
